import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enDs from "@gogive/design-system/locales/en/ds.json";

let initialized = false;

export function initCharityI18n() {
  if (initialized || i18n.isInitialized) {
    return i18n;
  }
  initialized = true;
  void i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    defaultNS: "translation",
    ns: ["translation", "ds"],
    resources: {
      en: {
        translation: {},
        ds: enDs,
      },
    },
    interpolation: { escapeValue: false },
  });
  return i18n;
}

export { i18n };
